import React, { useState } from "react";
import { useRouter } from 'next/router'
import { Form } from "react-final-form";
import { useSelector, useDispatch } from 'react-redux'

// actions
import { toggleDrawer } from '~/slices/commons/drawer'
import { setSearchOptions, resetSearchOptions, setSearchType } from '~/slices/items/itemSearchOption'

// components
import FormButton from "../atoms/FormButton";
import {ItemCategoryField} from "../molecules/ItemCategoryField";
import {ItemNameField} from "../molecules/ItemNameField";
import {ItemSubCategoryField} from "../molecules/ItemSubCategoryField";
import {SeasonTagField} from "../molecules/SeasonTagField";
import {CookingStyleField} from "../molecules/CookingStyleField";
import {PackingStyleField} from "../molecules/PackingStyleField";
import {SearchItemOtherOptions} from "../molecules/SearchItemOtherOptions";
import {SetCategoryField} from "../molecules/SetCategoryField";
import {EnergyField} from "../organisms/EnergyField";
import {AllergenField} from "../organisms/AllergenField";
import {SaltField} from "../organisms/SaltField";
import {Button, Divider, Grid, InputAdornment} from "@material-ui/core";
import colorPalette from "../../../styles/theme/colorPalette";
import NeutralButton from "../../atoms/NeutralButton";

export const ItemSearchForm = () => {
  const dispatch = useDispatch()
  const router = useRouter()

  const itemSearchOptionState = useSelector((state) => state.itemSearchOption)

  const initialValues = {
    ...itemSearchOptionState.searchOptions
  }

  const submitSearchParams = (value) => {
    // ItemSearchOptionsStateにdispatch
    dispatch(setSearchOptions(value))
    dispatch(setSearchType('searchOptions'))
    dispatch(toggleDrawer({openFlg: false, key: 'search'}))

    const pathname = '/items/'
    router.push(pathname)
  }

  const resetParams = async() => {
    await dispatch(resetSearchOptions())
  }

  return (
      <Form
          onSubmit={submitSearchParams}
          initialValues={initialValues}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} >
                <div css={{maxHeight: 'calc(100vh - 280px)', overflowY: 'auto', paddingBottom:'16px'}}>
                  <PackingStyleField/>
                  <Divider css={{margin: '16px 0'}}/>
                  {
                    values.packingStyle !== 'set' &&
                    <Grid
                        container
                        justifyContent="flex-start"
                        alignItems='flex-start'
                    >
                      <Grid item lg={4}>
                        <ItemCategoryField/>
                      </Grid>
                      <Grid item lg={8}>
                        <ItemNameField/>
                        <Divider css={{margin: '16px 0'}}/>
                        <ItemSubCategoryField/>
                        <SeasonTagField/>
                        <CookingStyleField/>
                        <SearchItemOtherOptions/>
                        <Divider css={{margin: '16px 0'}}/>
                        <EnergyField/>
                        <SaltField/>
                        <Divider css={{margin: '16px 0'}}/>
                        <AllergenField/>
                      </Grid>
                    </Grid>
                    ||
                    <>
                      <SetCategoryField/>
                    </>
                  }
                </div>
                <Divider css={{margin: '0 0 16px'}}/>
                <Grid container justifyContent={'center'} flexDirection={'row'} css={{height: '40px'}}>
                  <Grid item css={{margin:'0 8px 0 0'}}>
                    <NeutralButton
                        maxWidth={'124px'}
                        minWidth={'124px'}
                        hexColorCode={colorPalette.gray}
                        text={'条件をリセット'}
                        onClick={() => resetParams().then(form.reset)}
                    />
                  </Grid>
                  <Grid item css={{margin:'0 0 0 8px'}}>
                    <FormButton
                        text_first={"検索"}
                        submitting={submitting}
                        minWidth={'124px'}
                        maxWidth={'124px'}
                        arrow_icon={false}
                        style={{margin:'0',backgroundColor: colorPalette.primary, color: 'white'}}
                    />
                  </Grid>
                </Grid>
              </form>
          )}
      />
  )
}
